/**
 * Skeleton, dance clips, locomotion pose.
 */
import { D, O, ye } from "../math.js";

export const Ie = [`root`, `hips`, `spine`, `head`, `lUpperArm`, `lForeArm`, `rUpperArm`, `rForeArm`, `lThigh`, `lShin`, `rThigh`, `rShin`];
export const Le = Ie.length;
export const N = Object.fromEntries(Ie.map((e, t) => [e, t]));
export const Re = [-1, 0, 1, 2, 2, 4, 2, 6, 1, 8, 1, 10];
export const P = {
        hipY: .961,
        waistY: 1.05,
        neckY: 1.404,
        shoulderX: .156,
        shoulderY: 1.341,
        upperArm: .23,
        foreArm: .25,
        hipX: .087,
        hipJointY: .912,
        thigh: .42,
        shin: .44
    };
export const ze = [
        [0, 0, 0],
        [0, P.hipY, 0],
        [0, P.waistY, 0],
        [0, P.neckY, 0],
        [-P.shoulderX, P.shoulderY, 0],
        [-P.shoulderX, P.shoulderY - P.upperArm, 0],
        [P.shoulderX, P.shoulderY, 0],
        [P.shoulderX, P.shoulderY - P.upperArm, 0],
        [-P.hipX, P.hipJointY, 0],
        [-P.hipX, P.hipJointY - P.thigh, 0],
        [P.hipX, P.hipJointY, 0],
        [P.hipX, P.hipJointY - P.thigh, 0]
    ];

export function Be() {
    return {
        x: 0,
        y: 0,
        z: 0,
        yaw: 0,
        r: Ie.map(() => [0, 0, 0])
    }
}

export function Ve(e, t = Be()) {
    t.x = e.x, t.y = e.y, t.z = e.z, t.yaw = e.yaw;
    for (let n = 0; n < Le; n++) t.r[n][0] = e.r[n][0], t.r[n][1] = e.r[n][1], t.r[n][2] = e.r[n][2];
    return t
}

export function He(e, t, n, r = Be()) {
    r.x = e.x + (t.x - e.x) * n, r.y = e.y + (t.y - e.y) * n, r.z = e.z + (t.z - e.z) * n, r.yaw = e.yaw + (t.yaw - e.yaw) * n;
    for (let i = 0; i < Le; i++) {
        let a = e.r[i],
            o = t.r[i],
            s = r.r[i];
        s[0] = a[0] + (o[0] - a[0]) * n, s[1] = a[1] + (o[1] - a[1]) * n, s[2] = a[2] + (o[2] - a[2]) * n
    }
    return r
}

export function F(e, t, n = 0) {
    let r = P.thigh,
        i = Math.max(-1, Math.min(1, 1 - Math.max(0, t) / (2 * r))),
        a = Math.acos(i);
    e.y -= Math.max(0, t), e.r[N.lThigh][0] += -a, e.r[N.rThigh][0] += -a, e.r[N.lShin][0] += 2 * a, e.r[N.rShin][0] += 2 * a, e.r[N.lThigh][2] += -n, e.r[N.rThigh][2] += n, e.r[N.spine][0] += a * .35
}

export function Ue() {
    let e = new Float32Array(16);
    return e[0] = e[5] = e[10] = e[15] = 1, e
}

export function We(e, t, n, r, i, a, o) {
    let s = Math.cos(t),
        c = Math.sin(t),
        l = Math.cos(n),
        u = Math.sin(n),
        d = Math.cos(r),
        f = Math.sin(r),
        p = d,
        m = f * s,
        h = f * c,
        g = -f,
        _ = d * s,
        v = d * c,
        y = -c,
        b = s;
    e[0] = p * l + h * u, e[1] = m, e[2] = -p * u + h * l, e[3] = 0, e[4] = g * l + v * u, e[5] = _, e[6] = -g * u + v * l, e[7] = 0, e[8] = 0 * l + b * u, e[9] = y, e[10] = -0 * u + b * l, e[11] = 0, e[12] = i, e[13] = a, e[14] = o, e[15] = 1
}

export function Ge(e, t, n) {
    for (let r = 0; r < 4; r++) {
        let i = t[r * 4],
            a = t[r * 4 + 1],
            o = t[r * 4 + 2],
            s = t[r * 4 + 3];
        e[r * 4] = i * n[0] + a * n[4] + o * n[8] + s * n[12], e[r * 4 + 1] = i * n[1] + a * n[5] + o * n[9] + s * n[13], e[r * 4 + 2] = i * n[2] + a * n[6] + o * n[10] + s * n[14], e[r * 4 + 3] = i * n[3] + a * n[7] + o * n[11] + s * n[15]
    }
}
export const Ke = Ue();
export const qe = Ie.map(() => Ue());
export const Je = Ue();

export function Ye(e, t) {
    let n = Re[t],
        r = ze[t];
    if (n < 0) We(Ke, 0, e.yaw, 0, r[0] + e.x, r[1] + e.y, r[2] + e.z), qe[t].set(Ke);
    else {
        let i = e.r[t],
            a = ze[n];
        We(Ke, i[0], i[1], i[2], r[0] - a[0], r[1] - a[1], r[2] - a[2]), Ge(qe[t], Ke, qe[n])
    }
}

export function Xe(e, t, n = 0) {
    for (let r = 0; r < Le; r++) {
        let i = ze[r];
        Ye(e, r);
        let a = qe[r];
        Je.set(a), Je[12] = a[12] - (i[0] * a[0] + i[1] * a[4] + i[2] * a[8]), Je[13] = a[13] - (i[0] * a[1] + i[1] * a[5] + i[2] * a[9]), Je[14] = a[14] - (i[0] * a[2] + i[1] * a[6] + i[2] * a[10]), t.set(Je, n + r * 16)
    }
}
export const Ze = [0, .17, .1];

export function Qe(e, t = [0, 0, 0]) {
    for (let t = 0; t <= N.head; t++) Ye(e, t);
    let n = qe[N.head],
        [r, i, a] = Ze;
    return t[0] = r * n[0] + i * n[4] + a * n[8] + n[12], t[1] = r * n[1] + i * n[5] + a * n[9] + n[13], t[2] = r * n[2] + i * n[6] + a * n[10] + n[14], t
}
export const $e = Math.PI * 2;
export const et = e => ((1 + Math.cos($e * e)) / 2) ** 2;

export function I(e, t, n, r, i) {
    let a = e.r[t];
    a[0] = n, a[1] = r, a[2] = i
}

export function L(e, t, n, r, i) {
    let a = e.r[t];
    a[0] += n, a[1] += r, a[2] += i
}

export function tt(e) {
    e.x = e.y = e.z = e.yaw = 0;
    for (let t of e.r) t[0] = t[1] = t[2] = 0
}

export function nt(e, t = 0) {
    I(e, N.lUpperArm, -.08 + t, 0, -.14), I(e, N.rUpperArm, -.08 - t, 0, .14), I(e, N.lForeArm, -.35, 0, 0), I(e, N.rForeArm, -.35, 0, 0)
}

export function R(e, t, n, r = .3, i = .15) {
    let a = t === `l` ? -1 : 1;
    I(e, t === `l` ? N.lUpperArm : N.rUpperArm, -n, 0, a * r), I(e, t === `l` ? N.lForeArm : N.rForeArm, -i, 0, 0)
}

export function z(e, t, n, r = .25, i = 1.35) {
    let a = t === `l` ? -1 : 1;
    I(e, t === `l` ? N.lUpperArm : N.rUpperArm, -.35 + n, 0, a * r), I(e, t === `l` ? N.lForeArm : N.rForeArm, -i, 0, 0)
}
export const rt = [`bounce`, `pump`, `handsUp`, `twoStep`, `shuffle`, `wave`, `clap`, `nod`, `jump`, `point`, `cheer`];
export const it = [`bounce`, `pump`, `handsUp`, `twoStep`, `shuffle`, `wave`, `clap`, `nod`, `point`, `bounce`, `nod`, `twoStep`];
export const at = {
        loop: `nod`,
        offset: 0,
        half: !1
    };
export const ot = (e, t) => ye((e.half ? t / 2 : t) + e.offset, 4);
export const st = (e, t) => e.loop === t.loop && e.offset === t.offset && e.half === t.half;

export function ct(e, t, n) {
    tt(n);
    let r = et(t),
        i = Math.sin($e * t / 2);
    switch (e) {
        case `bounce`:
            nt(n, Math.sin($e * t) * .12), z(n, `l`, Math.sin($e * t) * .25, .3, 1.1), z(n, `r`, -Math.sin($e * t) * .25, .3, 1.1), F(n, .07 * r), I(n, N.head, .16 * r, 0, 0), L(n, N.spine, .04 * r, i * .08, 0);
            break;
        case `pump`: {
            let e = O(D(1 - t % 1 * 1.8));
            I(n, N.rUpperArm, -1.6 - 1.2 * e, 0, .25), I(n, N.rForeArm, -1.1 + .9 * e, 0, 0), z(n, `l`, .1, .35, 1.3), F(n, .06 * r), I(n, N.head, .2 * r - .08, 0, 0), L(n, N.spine, .05 * r, 0, 0);
            break
        }
        case `handsUp`: {
            let e = i;
            R(n, `l`, 2.75 + .1 * r, .35 + e * .15, .25), R(n, `r`, 2.75 + .1 * r, .35 - e * .15, .25), F(n, .06 * r), L(n, N.spine, -.05, e * .12, e * .08), I(n, N.head, -.15 + .12 * r, e * .1, 0);
            break
        }
        case `twoStep`: {
            let e = i;
            n.x = e * .1, z(n, `l`, e * .35, .3, 1.25), z(n, `r`, -e * .35, .3, 1.25), F(n, .05 * r, .06), L(n, N.lThigh, 0, 0, -Math.max(0, -e) * .18), L(n, N.rThigh, 0, 0, Math.max(0, e) * .18), L(n, N.spine, .03, 0, -e * .1), I(n, N.head, .12 * r, e * .15, e * .08);
            break
        }
        case `shuffle`: {
            let e = Math.sin($e * t),
                i = Math.sin($e * t * .5);
            I(n, N.lThigh, -Math.max(0, i) * .55, 0, -.04), I(n, N.lShin, Math.max(0, i) * .8, 0, 0), I(n, N.rThigh, -Math.max(0, -i) * .55, 0, .04), I(n, N.rShin, Math.max(0, -i) * .8, 0, 0), n.y = -.03 * r + Math.abs(i) * .03, z(n, `l`, -i * .55, .2, 1.4), z(n, `r`, i * .55, .2, 1.4), I(n, N.spine, .1, i * .12, 0), I(n, N.head, .1 * r, 0, e * .05);
            break
        }
        case `wave`: {
            let e = Math.sin($e * t / 2 + .6);
            R(n, `l`, 2.6, .3 + e * .55, .3), R(n, `r`, 2.6, .3 - e * .55, .3), L(n, N.spine, 0, e * .1, -e * .12), F(n, .04 * r), I(n, N.head, -.1, e * .12, -e * .1), n.yaw = e * .08;
            break
        }
        case `clap`: {
            let e = (t + 1) % 2,
                i = O(D(1 - Math.abs(e - 0) * 3)) + O(D(1 - Math.abs(e - 2) * 3));
            R(n, `l`, 2.55, .55 - i * .5, .35 + i * .2), R(n, `r`, 2.55, .55 - i * .5, .35 + i * .2), F(n, .06 * r), I(n, N.head, -.1 + .1 * r, 0, 0);
            break
        }
        case `nod`: {
            let e = i;
            nt(n, 0), z(n, `l`, .05 + e * .08, .25, .9), z(n, `r`, .05 - e * .08, .25, .9), F(n, .035 * r), L(n, N.spine, .02, e * .06, e * .05), I(n, N.head, .22 * r - .04, e * .08, 0);
            break
        }
        case `jump`: {
            let e = t % 1,
                r = e < .12 ? 0 : Math.sin((e - .12) / .88 * Math.PI),
                i = e < .12 ? 1 - e / .12 : 0;
            n.y = r * .32, F(n, i * .14), L(n, N.lThigh, -r * .35, 0, 0), L(n, N.rThigh, -r * .35, 0, 0), L(n, N.lShin, r * .7, 0, 0), L(n, N.rShin, r * .7, 0, 0), R(n, `l`, 2.4 + r * .4, .4, .2), R(n, `r`, 2.4 + r * .4, .4, .2), I(n, N.head, -.2 * r, 0, 0);
            break
        }
        case `point`: {
            let e = Math.floor(t) % 2 == 0,
                i = O(D(1 - t % 1 * 1.6));
            e ? (R(n, `r`, 2.2 + i * .6, .35, .05), z(n, `l`, .2, .3, 1.4)) : (R(n, `l`, 2.2 + i * .6, .35, .05), z(n, `r`, .2, .3, 1.4)), F(n, .06 * r), L(n, N.spine, .03, e ? .12 : -.12, 0), I(n, N.head, -.15, e ? .15 : -.15, 0);
            break
        }
        case `cheer`: {
            let e = Math.sin($e * t * 4);
            R(n, `l`, 2.8, .45 + e * .12, .2), R(n, `r`, 2.8, .45 - e * .12, .2);
            let r = t * 2 % 1;
            n.y = Math.sin(r * Math.PI) * .1, I(n, N.head, -.25, 0, e * .05), L(n, N.spine, -.08, 0, 0);
            break
        }
    }
}
export const lt = .95;

export function ut(e) {
    return e < 0 || e >= lt ? 0 : e < .1 ? O(e / .1) : e < lt * .55 ? 1 : 1 - O((e - lt * .55) / (lt * .45))
}

export function dt(e, t, n) {
    tt(n);
    let r = D(t);
    switch (e) {
        case `left`:
        case `right`: {
            let t = e === `left` ? -1 : 1,
                r = e === `left` ? `l` : `r`,
                i = e === `left` ? `r` : `l`;
            I(n, r === `l` ? N.lUpperArm : N.rUpperArm, -1.45, 0, t * .35), I(n, r === `l` ? N.lForeArm : N.rForeArm, -.05, 0, 0), z(n, i, .4, .3, 1.6), n.x = t * .16, n.yaw = t * .55, F(n, .1, .12), L(n, r === `l` ? N.lThigh : N.rThigh, 0, 0, t * .25), L(n, N.spine, .05, t * .15, -t * .18), I(n, N.head, .05, t * .35, 0);
            break
        }
        case `up`:
            R(n, `l`, 2.95, .28, .05), R(n, `r`, 2.95, .28, .05), n.y = Math.sin(r * Math.PI) * .12, L(n, N.spine, -.12, 0, 0), I(n, N.head, -.3, 0, 0);
            break;
        case `down`:
            F(n, .34, .2), I(n, N.lUpperArm, -.5, 0, -.75), I(n, N.rUpperArm, -.5, 0, .75), I(n, N.lForeArm, -.4, 0, 0), I(n, N.rForeArm, -.4, 0, 0), L(n, N.spine, .28, 0, 0), I(n, N.head, .35, 0, 0)
    }
}

export function ft(e, t, n) {
    tt(n);
    let r = et(e),
        i = Math.sin($e * e / 2);
    I(n, N.spine, .28 + .05 * r, i * .08, 0), I(n, N.head, .25 * r + .05, i * .1, 0), I(n, N.lUpperArm, -.75, 0, -.18), I(n, N.lForeArm, -.95 + Math.sin($e * e * 2) * .05, 0, 0), I(n, N.rUpperArm, -.75 - t * 2.1, 0, .18 + t * .2), I(n, N.rForeArm, -.95 + t * .85, 0, 0), F(n, .04 * r)
}

export function pt(e, t) {
    tt(t);
    let n = D(e.speed),
        r = D(e.speed - 1),
        i = e.phase,
        a = Math.sin(i),
        o = Math.cos(i),
        s = Math.sin(e.time * 1.7) * .02 * (1 - n);
    nt(t, 0), L(t, N.spine, s, 0, 0), I(t, N.head, .04 - s, Math.sin(e.time * .37) * .08 * (1 - n), 0);
    let c = .42 * n + .28 * r,
        l = .55 * n + .75 * r;
    I(t, N.lThigh, -a * c, 0, -.02), I(t, N.rThigh, a * c, 0, .02), I(t, N.lShin, Math.max(0, o) * l + .08 * n, 0, 0), I(t, N.rShin, Math.max(0, -o) * l + .08 * n, 0, 0), t.y = -Math.abs(o) * (.03 * n + .04 * r) + (.02 * n + .05 * r) * Math.abs(a);
    let u = .35 * n + .35 * r;
    if (I(t, N.lUpperArm, a * u - .05, 0, -.12), I(t, N.rUpperArm, -a * u - .05, 0, .12), I(t, N.lForeArm, -.3 - .9 * r - Math.max(0, a) * .3 * n, 0, 0), I(t, N.rForeArm, -.3 - .9 * r - Math.max(0, -a) * .3 * n, 0, 0), L(t, N.spine, .06 * n + .16 * r, a * .08 * n, e.lean * .5), t.yaw = 0, e.air > .001) {
        let n = e.air,
            r = .35 + .25 * Math.max(0, e.rise);
        t.r[N.lThigh][0] += (-r - t.r[N.lThigh][0]) * n, t.r[N.rThigh][0] += (-r * .4 - t.r[N.rThigh][0]) * n, t.r[N.lShin][0] += (.9 - t.r[N.lShin][0]) * n, t.r[N.rShin][0] += (.5 - t.r[N.rShin][0]) * n, t.r[N.lUpperArm][2] += (-.8 - t.r[N.lUpperArm][2]) * n, t.r[N.rUpperArm][2] += (.8 - t.r[N.rUpperArm][2]) * n, t.r[N.lUpperArm][0] += (-.6 - t.r[N.lUpperArm][0]) * n, t.r[N.rUpperArm][0] += (-.6 - t.r[N.rUpperArm][0]) * n, t.y *= 1 - n
    }
    e.land > .001 && F(t, .16 * e.land)
}

export { Be as emptyPose, pt as applyLocomotion, rt as DANCE_NAMES };
